import type { ZIndex } from '@sds-system/types';

export const zIndex: ZIndex = {
  0: 0,
  1000: 1000,
  1020: 1020,
  1030: 1030,
  1040: 1040,
  1050: 1050,
  1060: 1060,
  1070: 1070,
  1080: 1080,
  1090: 1090,
  9999: 9999,
  10000: 10000,
};
